import * as React from 'react';

import type { Props as PlainDatePickerProps } from 'af-components/Controls/DateInput';
import DateInput from 'af-components/Controls/DateInput';

import styles from './styles.module.scss';
import type { CellError } from '../../error.types';

type Props = PlainDatePickerProps & {
	elementKey: string;
	placeholder?: string;
	className?: string;
	error?: CellError;
	readonly?: boolean;
};

function DisplayCell(props): React.ReactElement<Props> {
	const { elementKey, value, error } = props;

	// QA id is automatically generated to help with automated tests
	// We want to avoid accidentally forgetting to place an id on an element, making it harder for QA to write automated tests, so we keep it generated
	// Styling should never come from id, anyway
	const id = React.useMemo(() => (
		`accqa__datepicker__display__${elementKey}`
	), [elementKey]);

	const datePickerClassName = React.useMemo(() => {
		if (!error) {
			return undefined;
		}
		return styles['error-msg'];
	}, [error]);

	return (
		<>
			<DateInput
				{...props}
				datePickerClassName={datePickerClassName}
				error={error?.message}
				fixed={true}
				id={id}
				isStandalone={true}
				key={elementKey}
				placeholderText="N/A"
				selectedValue={value ?? undefined}
				showTodayButton={false}
			/>
		</>
	);
}

export default React.memo(DisplayCell) as typeof DisplayCell;
